// axios
import axios from 'axios'
// Vuex Store
//const baseURL = 'http://182.160.118.196:5000/bml-ha/'
const baseURL = 'https://ho.butterflygroupbd.com/bml-ha/'
//const API_URL = 'https://ho.butterflygroupbd.com/showroom-backend/api'
const API_URL = 'https://ho.butterflygroupbd.com/showroom-backend/api'
//const baseURL = 'http://localhost:8080/api/'

export default axios.create({
  baseURL,
  API_URL,
  timeout: 100000,
  headers: {
    'accept': 'application/json',
    'Content-Type': 'application/json'
  }
  // You can add your headers here
})
